<template>
    <jb-buttons no-wrap>
        <jb-button color="info" class="buttons" title="Detail" :icon="mdiMagnify" small @click="showDetail" />
        <jb-button color="success" class="buttons" title="Approve" :icon="mdiCheckBold" small @click="approveAction('Approved')" v-if="this.params.data.state == 'Waiting for Approval' && (this.params.data.is_approve == true || this.params.data.is_approve == 'true')" />
        <jb-button color="danger" class="buttons" title="Reject" :icon="mdiAlphaXCircleOutline" small @click="approveAction('Rejected')" v-if="this.params.data.state == 'Waiting for Approval' && (this.params.data.is_approve == true || this.params.data.is_approve == 'true')" />

        <!-- <jb-button color="warning" class="buttons" title="UnApprove / UnReject" :icon="mdiAlphaXCircleOutline" small @click="approveAction('Remove')" v-if="checkUser && this.params.data.can_unapprove > 0 && this.params.data.user_status_room == 'ROOM_MANAGER'" /> -->
    </jb-buttons>
</template>
<script>
    import JbButtons from '@/components/JbButtons'
    import JbButton from '@/components/JbButton'
    import { onMounted, ref } from '@vue/runtime-core'
    import {
        mdiCircleEditOutline,
        mdiCheckBold,
        mdiAlphaXCircleOutline,
        mdiTrashCan,
        mdiMagnify,
        mdiAccount
    } from '@mdi/js'
    import CryptoJS from 'crypto-js'

    export default {
        name: 'ButtonActionRender',
        components: {
            JbButtons,
            JbButton
        },
        setup (props) {
            const userRole = localStorage.getItem('roles')
            const checkUser = ref(false)
            const userCheck = async () => {
                if (userRole !== null) {
                    const decryptedMessage = CryptoJS.AES.decrypt(localStorage.getItem('role'), 'amatra1609').toString(CryptoJS.enc.Utf8)
                    const myArray = decryptedMessage.split(',')
                    for (let i = 0; i < myArray.length; i++) {
                        if (myArray[i] === 'ROLE_ADMIN' || myArray[i] === 'ROLE_ADMIN_HRD' || myArray[i] === 'ROLE_ADMIN_FINANCE' || myArray[i] === 'ROLE_TEACHER' || myArray[i] === 'ROLE_BOOKING') {
                            checkUser.value = true
                        }
                    }
                }
            }
            onMounted(() => {
                userCheck()
            })
            return {
                userRole,
                userCheck,
                checkUser,
                mdiCircleEditOutline,
                mdiCheckBold,
                mdiAlphaXCircleOutline,
                mdiTrashCan,
                mdiAccount,
                mdiMagnify
            }
        },
        methods: {
            showDetail (event) {
                // the grid component can now be accessed via this.params.context.componentParent
                this.params.context.componentParent.detailData(event, this.params.data, this.params.data.id)
            },
            approveAction (text) {
                this.params.context.componentParent.approveClick(text, this.params.data, this.params.value)
            }
        }
    }
</script>
